
import React from 'react';
import _get from 'lodash/get';
import { compose } from 'recompose';
import { hot } from 'react-hot-loader';
import styled from 'styled-components';
import SignatureCanvas from 'react-signature-canvas';
import { Segment, Modal, Form, Label, Button, Image, Icon } from 'semantic-ui-react';

import { withLocale } from 'op/components/locale';
import { withSignatureModal } from './signature-modal.helper';

const SIG_WIDTH = 600;
const SIG_HEIGHT = 300;

const SigWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	canvas {
		background-color: white;	
	}
`;

export const SignaturePreview = styled.img`
	width: 100%;
	min-height: 150px;

	max-width: ${SIG_WIDTH}px;
	max-height: ${SIG_HEIGHT}px;

	border: ${({ src, color }) => !src ? 'solid 2px ' + (color || 'red') : 'none'};
	border-radius: 5px;
`;

const ReportSignatrue = ({ locale, report, isOpen, type, color, registerSignatrue, submit, open, close }) => (
	<Modal
		trigger={ 
			<SignaturePreview rounded color={color} onClick={open} src={ report.signatures[type] } />
		}
		open={isOpen}
		onClose={close}
		basic
	>
		<Modal.Content>
			<SigWrapper>
				<SignatureCanvas 
					ref={(dom) => dom && registerSignatrue(type, dom)}
					penColor={color}
					canvasProps={{width: SIG_WIDTH, height: SIG_HEIGHT}} />
			</SigWrapper>
		</Modal.Content>
		<Modal.Actions>
			<Button basic onClick={close} color='red' inverted>
				<Icon name='remove' /> { locale._system.cancel }
			</Button>
			<Button onClick={submit} color='green' inverted>
				<Icon name='checkmark' /> { locale._system.save }
			</Button>
		</Modal.Actions>
	</Modal>
);

export default compose(
	hot(module),
	withLocale(),
	withSignatureModal,
)(ReportSignatrue);